var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        ((_obj = { avatar: true, checked: _vm.checked }),
        (_obj[_vm.typeNetwork] = true),
        (_obj.toggleDisplayReseau = _vm.toggleDisplayReseau),
        _obj),
      on: {
        click: function($event) {
          return _vm.$emit("click", $event, _vm.id)
        }
      }
    },
    [
      _c("img", {
        attrs: { src: _vm.urlPicture ? _vm.urlPicture : "img/avatar.jpg" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }